import { z } from 'zod'
import { updatePasswordSchema } from './schemas'

export const loginSchema = z.object({
  username: z.string({ required_error: 'Login nie może być pusty' }),
  password: z.string({ required_error: 'Hasło nie może być puste' }),
})

export type Login = z.infer<typeof loginSchema>

export type Account = {
  id: string
  username: string
  firstName: string
  lastName: string
  roles: Array<Role>
  active: boolean
  allowedIPs: Array<string>
}

export type Role = { id: string; name: string }

export enum RoleName {
  ADMIN = 'Administrator',
  TEST = 'Test',
}

export type UpdatePassword = z.infer<typeof updatePasswordSchema>
